<template>
  <div>
    <el-dialog class="customer-batch-invoice-upload-dialog"
               title="批量更新开票信息"
               :visible.sync="visible"
               :before-close="closeDialog">
      <el-row class="batch-invoice-upload-row">
        <el-upload class="upload-batch-invoice"
                   ref="upload"
                   action=""
                   :file-list="uploadFileList"
                   :on-change="(file, fileList) => {onChangeUploadFile(file, fileList, 10)}"
                   :on-remove="onRemoveUploadFile"
                   accept=".xlsx,.xls"
                   :auto-upload="false">
          <el-button icon=""
                     type="primary"
                     size="medium">上传文件
          </el-button>
        </el-upload>
        <el-button size="medium"
                   type="text"
                   @click="downCustomerInvoiceUploadTpl">下载模板
        </el-button>
      </el-row>
      <el-row>
        <button-gutter style="float: right;">
          <el-button size="medium"
                     @click="onCancelUpload">取消
          </el-button>
          <el-button type="primary"
                     size="medium"
                     @click="onSubmitUpload(235)">确定
          </el-button>
        </button-gutter>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import customerMixins from '../customer.mixins'

export default {
  mixins: [customerMixins],
  data () {
    return {
      uploadFileList: [],
    }
  },
  props: {
    visible: Boolean,
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    },

    onCancelUpload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.closeDialog()
    },

    onSubmitUpload (type) {
      if (this.uploadFileList.length < 1) {
        this.$message.error('请选择合适的 excel 文件!')
        return false
      }
      this.onUploadFile(this.uploadFileList[0], type)
    },

    onChangeUploadFile (file, fileList, size = 10) {
      let isLimit = file.raw.size / 1024 / 1024 < size
      if (!isLimit) {
        this.$message.error(`文件大小不能超过${size}MB!`)
        this.$refs.upload.clearFiles()
        return false
      }

      this.uploadFileList = fileList
      fileList.splice(0, fileList.length - 1)
    },

    onRemoveUploadFile (file, fileList) {
      this.uploadFileList = fileList
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/customer/components/CustomerBatchInvoiceUploadDialog.vue